// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {CourseScreenLayout} from 'app_components/screens/landing/course'
// @end

// @INFO Import types
import { ICourse } from 'app_types/campus/academic/courseTypes'
// @end

// @import services
import CourseService from 'app_services/campus/academic/courseService'
// @end

// @ADD Component types
interface ICourseScreenProps {
  match?: any
  slug_type: string
}
interface ICourseScreenState {
  course: ICourse | null
  status: null | 'loading' | 'error'
}


class CourseScreen extends Component<ICourseScreenProps, ICourseScreenState> {

  private courseService: CourseService;

  constructor(props: ICourseScreenProps){
    super(props)
    this.state = {
      course: null,
      status: 'loading',
    }
    this.courseService = new CourseService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
   componentDidMount = async () => {
    if (this.props?.match?.params?.slug) {
      await this.getCourse(this.props?.match?.params?.slug)
    }
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = async (before: any, after: any) => {
    if (this.props?.match?.params?.slug !== before?.match?.params.slug) {
      await this.getCourse(this.props?.match?.params?.slug)
    }
  }

  // @Add custom methods

  getCourse = async (slug: string) => {
    this.setState({ status: 'loading' })

    let course: any = null

    const newsResponse = await this.courseService.fetchCourse(slug, {generate_pdf: true, slug_type: this.props.slug_type})

    if (newsResponse && newsResponse.course) {
      course = newsResponse.course
    }

    this.setState({
      course,
      status: null
    })
  }

  render() {
    return(
      <CourseScreenLayout
        programCourse={this.state.course}
        status={this.state.status}
      />
    )
  }
}

export default CourseScreen
